/**
 * Rappel « partage interdit » pour un abonné Premium (décision du 26/10/2026), sans rien bloquer :
 * capturer, calculer ou exporter pour soi reste libre, c'est le partage qui est interdit (CGV art. 9).
 * - Impression ou « Enregistrer en PDF » du navigateur : filigrane « Document tracé · <adresse> »
 *   discret et répété (div.km-trace-impression, SVG de filigrane.ts), invisible à l'écran.
 * - Touche Impr. écran (Windows, le seul système où le navigateur la voit, après la capture) :
 *   petite alerte en haut à droite, qui disparaît seule.
 * Commun aux pages serveur (nav.js) et à l'application React (AppLayout).
 */
import { adresseNonCliquable, filigraneSvg } from "./filigrane";

export const RAPPEL_PARTAGE = "Capture pour votre usage personnel : le partage des contenus Premium est interdit (CGV, article 9).";

const DUREE_MS = 5000;

export function afficherRappelPartage(doc: Document = document): void {
  let el = doc.querySelector<HTMLElement>(".km-rappel-partage");
  if (!el) {
    el = doc.createElement("div");
    el.className = "km-rappel-partage";
    el.setAttribute("role", "status");
    el.textContent = RAPPEL_PARTAGE;
    doc.body.appendChild(el);
  }
  const cible = el;
  window.clearTimeout(Number(cible.dataset.kmMinuteur ?? 0));
  cible.dataset.kmMinuteur = String(window.setTimeout(() => cible.remove(), DUREE_MS));
}

/** Installe le filigrane d'impression et l'écoute de la touche ; renvoie la fonction qui les retire. */
export function installerRappelPartage(doc: Document, email: string): () => void {
  doc.body.dataset.kmTrace = `Document tracé · ${adresseNonCliquable(email)}`;
  // Filigrane répété (filigrane.ts), masqué à l'écran, affiché par la feuille d'impression.
  doc.querySelector(".km-trace-impression")?.remove();
  const trace = doc.createElement("div");
  trace.className = "km-trace-impression";
  trace.setAttribute("aria-hidden", "true");
  trace.innerHTML = filigraneSvg(doc.body.dataset.kmTrace, 1400, 2000);
  doc.body.appendChild(trace);
  const surTouche = (e: KeyboardEvent) => {
    if (e.key === "PrintScreen") afficherRappelPartage(doc);
  };
  doc.addEventListener("keyup", surTouche);

  return () => {
    delete doc.body.dataset.kmTrace;
    trace.remove();
    doc.removeEventListener("keyup", surTouche);
  };
}
